import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		width: '400px',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	title: {
		fontSize: 16,
		color: THEME.colors.icon.primary,
	},
	toggleButtonsContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
	},
	toggleButton: {
		display: 'flex',
		// @ts-expect-error - this is a hack to get the alignItems to work
		alignItems: 'flex-start !important' as const,
		...CssSelectors.allChildren(
			{
				marginTop: THEME.spacing.xs,
			},
			'svg'
		),
	},
	buttonsContainer: {
		display: 'flex',
		justifyContent: 'flex-start',
		gap: THEME.spacing.md,
	},
	recommendedText: {
		color: THEME.colors.icon.primary,
	},
});
